<template>
  <div class="gallery-container">
    <vueper-slides
      class="no-shadow"
      :visible-slides="2"
      :arrows="false"
      :slide-ratio="1 / 4"
      :gap="1"
      :autoplay="true"
      fixed-height="100%"
      :dragging-distance="70">
      <vueper-slide v-for="(slide,s) in content.slides" :key="s" :image="slide.content" class="single-slide"/>
    </vueper-slides>
  </div>
</template>
<script>
import gsap from "gsap";
import { TimelineMax } from 'gsap'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
export default {
  props: ["content"],
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  },
  components: {
    VueperSlides,
    VueperSlide
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/bootstrap-grid.scss";
@import "@/assets/scss/fonts.scss";
.gallery-container{
  height: 350px;
  padding-top: 70px;
}

/* Smartphones (portrait and landscape) ----------- */
@media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
  .gallery-container{
    height: 400px;
  }
}
</style>
<style lang="scss">
@import "@/assets/scss/bootstrap-grid.scss";
@import "@/assets/scss/fonts.scss";
.gallery-container{
  .vueperslides__bullet{
    .default{
      width: 6px;
      height: 6px;
      border: 1px solid white;
    }
  }
  .vueperslides__bullet--active{
    .default{
      width: 6px;
      height: 6px;
      border: 1px solid white;
      background-color: white;
    }
  }
}
</style>